/**
 * Consent-gated Google Analytics events. gtag is configured by the "analytics marketing" block in index.html,
 * which <cookie-consent> activates once analytics or marketing consent is given.
 * Never throws and never blocks: analytics must not affect the app flow.
 */
export function hasGoogleTagConsent( win = window )
{
    try
    {
        const consent = win.cookieConsent?.getConsent?.();
        return !!consent?.timestamp && ( true === consent.choices?.analytics || true === consent.choices?.marketing );
    }
    catch ( e )
    {
        return false;
    }
}

/**
 * Sends exactly the GA4 recommended sign_up event (counted in GA4 with analytics consent,
 * imported into Google Ads with marketing consent). No email, user, organisation or document data.
 * @returns {boolean} true if the event was handed to gtag
 */
export function trackSignUp( region, win = window )
{
    try
    {
        if ( !hasGoogleTagConsent( win ) || true !== win.tmplvisionAnalyticsReady || 'function' !== typeof win.gtag )
        {
            return false;
        }
        win.gtag( 'event', 'sign_up', { method: 'email', region: 'us' === region ? 'us' : 'eu' } );
        return true;
    }
    catch ( e )
    {
        return false;
    }
}
